<template>
  <b-row class="login-container">
    <b-col cols="12">
      <b-row>
        <b-col
          cols="12"
          class="component input-form p-0"
        >
          <b-row class="m-0">
            <b-col cols="12">
              <b-row
                class="error-message-container mt-4 p-3"
                v-show="isError"
              >
                <b-col
                  cols="12"
                  class="text-center"
                >
                  <b-row>
                    <b-col
                      cols="8"
                      class="error-message"
                      offset-md="2"
                    >
                      {{ errorMessage }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row
                v-show="!submitted"
              >
                <b-col
                  v-if="!isBfmLogin && !isSelfSignInLogin"
                  cols="12"
                >
                  <b-row>
                    <b-col
                      cols="12"
                      class="text-center pb-4 pt-4 logo-container"
                    >
                      <img
                        src="../assets/BETS-e-logo.png"
                        class="logo"
                        width="250"
                      >
                    </b-col>
                  </b-row>
                  <b-row class="pt-5 d-flex justify-content-start">
                    <b-col
                      class="text-center text-md-right"
                      md="6"
                    >
                      <b-button
                        class="btn-green btn-nav"
                        style="width: 300px; height: 300px; border-radius: 40px;"
                        @click="activateSelfSignInLogin"
                      >
                        <h3>Self Screen</h3>
                      </b-button>
                    </b-col>
                    <b-col
                      class="text-center text-md-left"
                      md="6"
                    >
                      <b-button
                        class="btn-green btn-nav"
                        style="width: 300px; height: 300px; border-radius: 40px;"
                        @click="activateBfmLogin"
                      >
                        <h3>BFM Login</h3>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  v-if="isBfmLogin || isSelfSignInLogin"
                  cols="12"
                >
                  <b-row>
                    <b-col
                      cols="12"
                      class="text-center pb-4 pt-4 logo-container"
                    >
                      <img
                        src="../assets/BETS-e-logo.png"
                        class="logo"
                        width="250"
                      >
                    </b-col>
                    <!-- <b-col
                            cols="12"
                            class="text-center pt-4 px-4">
                            <p style="color: red; font-size: 24px;">
                              We are now working on removing all of your test data and provisioning the system to begin live use at 3pm CST.
                            </p>
                          </b-col> -->
                  </b-row>

                  <b-row class="justify-content-center pt-5">
                    <b-col
                      v-if="isKioskEnabled && isSelfSignInLogin"
                      cols="6"
                      size="lg"
                      class="d-flex justify-content-center flex-column"
                    >
                      <b-row class="justify-content-center no-gutters m-3">
                        <b-col cols="12">
                          <b-form-select
                            size="lg"
                            v-model="branch"
                            placeholder="Test"
                            :options="$store.state.branches"
                          />
                        </b-col>
                        <b-col class="text-center pt-5" cols="12">
                          <b-button
                            class="btn btn-green"
                            :disabled="this.branch === null"
                            @click="selfSignIn"
                          >
                            Submit
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col
                      v-if="isBfmLogin"
                      class="login-input-container"
                    >
                      <!-- <transition
                              name="slide2"
                              mode="out-in"
                            > -->
                      <b-form
                        v-show="!forgotPassword"
                        @submit.prevent="informationEntered"
                      >
                        <b-form-row>
                          <b-col
                            cols="12"
                            class="pb-3"
                          >
                            <b-form-input
                              v-model="itemMeta.username"
                              id="username"
                              size="lg"
                              type="text"
                              :state="isMissing($v.itemMeta.username.$error)"
                              @keyup.enter="informationEntered"
                              autocomplete="username email"
                              autofocus=""
                              placeholder="User ID"
                            />
                            <span v-if="$v.itemMeta.username.$dirty">
                              <div
                                class="invalid-feedback"
                                v-if="!$v.itemMeta.username.required"
                              >
                                User ID is required
                              </div>
                            </span>
                          </b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col
                            cols="12"
                            class="pb-3"
                          >
                            <b-form-input
                              v-model="itemMeta.password"
                              id="password"
                              size="lg"
                              type="password"
                              :state="isMissing($v.itemMeta.password.$error)"
                              @keyup.enter="informationEntered"
                              autocomplete="current-password"
                              placeholder="Password"
                            />
                            <span v-if="$v.itemMeta.password.$dirty">
                              <div
                                class="invalid-feedback"
                                v-if="!$v.itemMeta.password.required"
                              >
                                Password is required
                              </div>
                            </span>
                          </b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col
                            cols="12"
                            class="pb-3 text-center"
                          >
                            <b-button
                              class="login-button"
                              variant="green"
                              @click.stop.prevent="informationEntered"
                            >
                              Login
                            </b-button>
                          </b-col>
                        </b-form-row>
                      </b-form>
                      <!-- </transition> -->

                      <!-- <transition
                              name="slide2"
                              mode="out-in"
                            > -->
                      <b-row>
                        <b-col
                          v-show="forgotPassword"
                          cols="12"
                          class="pb-4"
                        >
                          <b-row>
                            <b-col
                              cols="12"
                              class="text-center mb-4"
                            >
                              Remember, utilize your Kronos login credentials to access BETS-e. Proceed to Kronos to
                              reset your password.
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col
                              cols="12"
                              class="pb-3 text-left"
                            >
                              <b-button
                                variant="green"
                                @click.stop.prevent="showHideForgotPassword"
                                class="forgot-option"
                              >
                                &laquo; Back to BETS-e
                              </b-button>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col
                              cols="12"
                            >
                              <b-button
                                variant="green"
                                :href="kronosUrl"
                                class="forgot-option"
                                target="_blank"
                              >
                                Proceed to Kronos
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <!-- </transition> -->

                      <b-row>
                        <b-col
                          v-if="!forgotPassword"
                          cols="12"
                          class="text-right"
                        >
                          <a
                            href=""
                            @click.stop.prevent="showHideForgotPassword"
                          >
                            Forgot Your Password?
                          </a>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <div v-if="isBfmLogin" class="questionnaire-bottom">
      <b-row>
        <b-col cols="12">
          v2022.0.1
        </b-col>
      </b-row>
    </div>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import localForage from 'localforage'

// function debug () {
//   console.log(arguments[0])
//   return arguments[0]
// }

export default {
  name: 'Login',
  data () {
    return {
      branch: null,
      forgotPassword: false,
      submitted: false,
      isError: false,
      errorMessage: '',
      kioskMode: false,
      itemMeta: {
        username: '',
        password: ''
      }
    }
  },
  validations: {
    itemMeta: {
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  mounted () {
    if (this.loggedIn) {
      this.redirectToHome()
    }
    this.setDiagnosticsSent(false)
    this.resetInitRetryAttempt()
    this.getBranchFromStorage()
  },
  computed: {
    kronosUrl () {
      return 'https://bfm.bickfordsl.com/wfc/navigator/logon'
    }
  },
  methods: {
    ...mapActions([
      'resetInitRetryAttempt',
      'activateSelfSignInLogin',
      'activateBfmLogin'
    ]),
    ...mapActions({
      login: 'authentication/login',
      setDiagnosticsSent: 'support/setDiagnosticsSent',
      simulateBranchId: 'authentication/simulateBranchId'
    }),
    ...mapGetters([
      'kioskEnabled'
    ]),
    async getBranchFromStorage () {
      console.log('GetBranchFromStorage')
      this.branch = await localForage.getItem('cached_branch')
    },
    selfSignIn () {
      this.itemMeta.username = this.$store.state.kioskUsername
      this.itemMeta.password = this.$store.state.kioskPassword
      this.$store.dispatch('activateKioskMode')
      // this.simulateBranchId(this.branch)
      this.$store.state.branch = this.branch

      console.log('Kiosk Password: ' + this.$store.state.kioskUsername)

      this.informationEntered()
    },
    async informationEntered () {
      this.$v.itemMeta.$touch()
      if (!this.$v.itemMeta.$invalid || this.isSelfMode) {
        this.isError = false
        const payload = {}

        if (this.isSelfMode) {
          payload.username = this.$store.state.kioskUsername
          payload.password = this.$store.state.kioskPassword
        } else {
          payload.username = this.itemMeta.username
          payload.password = this.itemMeta.password
        }

        const result = await this.login(payload)

        if (result === true) {
          if (this.kioskMode) {
            await this.$store.dispatch('activateKioskMode')
          }
          this.redirectToHome()
        } else {
          this.isError = true
          this.errorMessage = 'Oops, please try again. Remember, utilize your Kronos login credentials to access BETS-e.'
        }
      }
    },
    redirectToHome () {
      this.$router.push({ name: 'home' })
    },
    isMissing (isError) {
      return (!isError) ? null : false
    },
    showHideForgotPassword () {
      this.forgotPassword = !this.forgotPassword
    }
  }
}
</script>

<style scoped lang="scss">
.error-message-container {
  background-image: linear-gradient(to bottom, #f2dede 0, #e7c3c3 100%);
  border: 1px solid #dca7a7;
  border-radius: 1rem;

  .error-message {
    font-weight: bolder;
  }
}

.login-input-container {
  background-color: #d6d7d8;
  border-radius: 1rem;
  padding: 16px;
  max-width: 768px;
}

@media (min-width: 768px) {
  .login-input-container {
    padding: 48px;
  }

  .logo-container img {
    width: 350px;
  }
}

.invalid-feedback {
  display: inline-block;
}

.forgot-option,
.login-button {
  font-size: 1.6rem;
  height: inherit;
  margin: 0;
  width: 100%;
}

.slide-enter-active {
  -moz-transition-duration: 0.9s;
  -webkit-transition-duration: 0.9s;
  -o-transition-duration: 0.9s;
  transition-duration: 0.9s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-out;
  -webkit-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.slide-enter-to, .slide-leave {
  display: none;
  max-height: 500px;
}

.slide-enter, .slide-leave-to {
  display: block;
  max-height: 0;
}

.slide2 {
  transition: all .9s ease-in;
  height: 275px;
  overflow: hidden;
}

.slide2.v-enter, .slide2.v-leave {
  height: 0;
  opacity: 0;
}
</style>
